// @ts-expect-error TS7006 Issue #4120
const isSerializedState = (state) =>
    state && typeof state === 'object' && Array.isArray(state.richTextFormat);

export default isSerializedState;
